(() => {
  const root = document.querySelector('[data-hg-product]');
  if (!root) return;
  const packsBox = root.querySelector('.hg-packs');
  const fmt = root.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
  let current = null;

  function money(cents) {
    const v = (Math.round(cents) / 100).toFixed(2);
    const [i, dec] = v.split('.');
    const map = {
      amount: i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec,
      amount_no_decimals: i.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_with_comma_separator: i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec,
      amount_no_decimals_with_comma_separator: i.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      amount_with_space_separator: i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + dec,
      amount_with_apostrophe_separator: i.replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + dec
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => map[k] || map.amount);
  }

  // Recalcule les prix des packs (utile si le produit a plusieurs variantes)
  function reprice(base) {
    root.querySelectorAll('.hg-pack').forEach((p) => {
      const compare = base * +p.dataset.qty;
      const price = Math.round((compare * (100 - +p.dataset.discount)) / 100);
      const set = (sel, val) => p.querySelector(sel) && (p.querySelector(sel).textContent = money(val));
      set('[data-price]', price);
      set('[data-compare]', compare);
      set('[data-saved]', compare - price);
    });
  }

  function select(index) {
    const pack = root.querySelector(`.hg-pack[data-index="${index}"]`);
    if (!pack) return;
    current = pack;
    pack.querySelector('input[type=radio]').checked = true;
    root.querySelectorAll('.hg-pack').forEach((p) => p.classList.toggle('is-active', p === pack));
  }

  async function add(btn) {
    if (!current) return;
    const err = root.querySelector('.hg-error');
    err.hidden = true;
    const items = [{ id: +packsBox.dataset.variant, quantity: +current.dataset.qty || 1 }];
    current.querySelectorAll('.hg-upsell input:checked').forEach((c) => c.value && items.push({ id: +c.value, quantity: 1 }));
    if (!items[0].id) { err.textContent = 'Choisis un produit dans la section.'; err.hidden = false; return; }
    const after = root.dataset.after;
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (after === 'drawer' && drawer) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    btn.classList.add('is-loading');
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      if (after === 'checkout') return void (window.location.href = '/checkout');
      if (after === 'drawer' && drawer && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ ...data, id: items[0].id });
        document.dispatchEvent(new CustomEvent('hg:cart-updated'));
      } else {
        window.location.href = (window.routes?.cart_url || '/cart');
      }
    } catch (e) {
      err.textContent = e.message;
      err.hidden = false;
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  // Galerie
  const track = root.querySelector('.hg-slides');
  const thumbs = [...root.querySelectorAll('.hg-thumb')];
  const thumbTrack = root.querySelector('.hg-thumbs__track');
  let idx = 0;
  const goTo = (i) => {
    const kids = track.children;
    idx = Math.max(0, Math.min(i, kids.length - 1));
    thumbs.forEach((b, k) => b.classList.toggle('is-active', k === idx));
    const s = kids[idx];
    if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: 'smooth' });
    thumbs[idx]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  };
  let st;
  track.addEventListener('scroll', () => {
    clearTimeout(st);
    st = setTimeout(() => {
      const w = track.children[0]?.offsetWidth || 1;
      const i = Math.round(track.scrollLeft / (w + 10));
      if (i !== idx) { idx = i; thumbs.forEach((b, k) => b.classList.toggle('is-active', k === idx)); }
    }, 80);
  });
  function zoom(src) {
    const box = document.createElement('div');
    box.className = 'hg-zoom';
    box.innerHTML = `<img src="${src}" alt=""><button type="button" aria-label="Fermer">×</button>`;
    const close = () => { box.remove(); document.removeEventListener('keydown', esc); };
    const esc = (ev) => ev.key === 'Escape' && close();
    box.addEventListener('click', close);
    document.addEventListener('keydown', esc);
    document.body.appendChild(box);
  }

  root.addEventListener('change', (e) => {
    if (e.target.matches('.hg-pack input[type=radio]')) select(e.target.value);
    if (e.target.matches('.hg-variant')) {
      const o = e.target.selectedOptions[0];
      packsBox.dataset.variant = o.value;
      reprice(+o.dataset.price);
    }
  });
  root.addEventListener('click', (e) => {
    const t = e.target;
    const th = t.closest('.hg-thumb');
    if (th) goTo(+th.dataset.i);
    const ar = t.closest('.hg-thumbs__arrow');
    if (ar) goTo(idx + +ar.dataset.dir);
    const sl = t.closest('.hg-slide[data-full]');
    if (sl) zoom(sl.dataset.full);
    const btn = t.closest('[data-hg-add]');
    if (btn) { e.preventDefault(); add(btn); }
  });

  const def = root.querySelector('.hg-pack[data-default]') || root.querySelector('.hg-pack');
  if (def) select(def.dataset.index);
})();

// Mini-carrousel d'avis
document.querySelectorAll('[data-hg-slider]').forEach((el) => {
  const slides = [...el.querySelectorAll('.hg-mini__slide')];
  const dots = [...el.querySelectorAll('.hg-dots button')];
  if (slides.length < 2) return;
  let i = 0;
  const go = (n) => {
    i = (n + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
    dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
  };
  dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
  setInterval(() => go(i + 1), 5000);
});
